import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import imgurl from "../assests/images/imgurl";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveIcon from "@mui/icons-material/Remove";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  checkout,
  getAllProducts,
  getCartProducts,
  getProfile,
  removeFromCart,
  updateCartQuantity,
  updaterProfile,
  firstUserAddAddress,
  updateUserDefaultAddress,
} from "../api/api";
import axios from "axios";
import Sidebar from "./Sidebar";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AlertComp from "../Alert";

export default function CartPage() {
  const [items, setItems] = useState("10");
  const [cart, setCart] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const navigate = useNavigate();
  const [customerAddressId, setCustomerAddressId] = useState("");
  const [firstLoginUser, setFirstLoginUser] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [cityName, setCityName] = useState("");
  const [provinceName, setProvinceName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");

  // -----------------------------
  const [open, setOpen] = useState(false);
  const [modalopen, setModalOpen] = useState(false);
  const [addrarr, setaddrarr] = useState({});
  const [countryCode, setCountryCode] = useState("spain");
  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  useEffect(() => {
    getProfileDetails();
  }, []);

  function getaddr(e) {
    e.preventDefault();
    var serialize = require("form-serialize");
    var form = document.querySelector("#addressform");
    var obj = serialize(form, { hash: true });
    setaddrarr(obj);
    handleClose();
  }

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };
  // -----------------------------
  // useEffect(() => {
  //   getCartProducts().then((cartItems) => {
  //     setCart(cartItems);
  //     getAllProducts().then((products) => {
  //       const cartProductDetails = products.filter((product) =>
  //         cartItems.some((cartItem) => cartItem.productId === product.id)
  //       );
  //       setFilteredProducts(cartProductDetails);
  //     });
  //   });
  // }, []);

  useEffect(() => {
    // Get cart items from localStorage
    const cartItems = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(cartItems);

    // Fetch all products (from API or locally) and filter based on cart items
    getAllProducts().then((products) => {
      const cartProductDetails = products.filter((product) =>
        cartItems.some((cartItem) => cartItem.productId === product.id)
      );
      setFilteredProducts(cartProductDetails);
    });
  }, []);

  // Main Checkout Code
  // const handleCheckout = async () => {
  //   const url = await checkout();
  //   if (window.cordova) {
  //     // Open the URL in the In-App Browser
  //     const inAppBrowser = window.cordova.InAppBrowser.open(
  //       url,
  //       "_blank",
  //       "location=yes,toolbar=yes"
  //     );

  //     // Listen for the 'exit' event, which occurs when the In-App Browser is closed
  //     inAppBrowser.addEventListener("exit", () => {
  //       console.log("closeInApp Browser");
  //     });
  //   } else {
  //     window.location.href = url; // Redirect to Shopify Checkout
  //     window.open(url, "_blank");
  //   }
  // };

  const handleCheckout = async () => {
    try {
      // Get the cart from localStorage
      const cart = JSON.parse(localStorage.getItem("cart")) || [];

      if (cart.length === 0) {
        alert("Your cart is empty.");
        return;
      }

      // Make the API call to the backend to create the checkout using axios
      const response = await axios.post(
        "https://4b39-27-107-210-194.ngrok-free.app/api/items/createCheckout",
        { cart: cart }
      );

      if (response.data.success) {
        const url = response.data.checkoutUrl; // Get the checkout URL from the API response

        if (window.cordova) {
          // Open the URL in the In-App Browser if on a Cordova app
          const inAppBrowser = window.cordova.InAppBrowser.open(
            url,
            "_blank",
            "location=yes,toolbar=yes"
          );

          // Listen for the 'exit' event, which occurs when the In-App Browser is closed
          inAppBrowser.addEventListener("exit", () => {
            console.log("In-App Browser closed");
          });
        } else {
          // Otherwise, redirect to the Shopify checkout page in the browser
          window.location.href = url; // Redirect to Shopify Checkout
          window.open(url, "_blank"); // Also open in a new tab
        }
      } else {
        // Handle errors (if any) from the API response
        alert("Error creating checkout: " + response.data.message);
      }
    } catch (error) {
      console.error("Error during checkout:", error);
      alert("An error occurred while processing your checkout.");
    }
  };

  // const handleRemoveFromCart = async (productId) => {
  //   const updatedCart = await removeFromCart(productId);
  //   setCart(updatedCart);
  //   setFilteredProducts(
  //     filteredProducts.filter((product) => product.id !== productId)
  //   );
  // };

  const handleRemoveFromCart = (productId) => {
    // Get current cart from localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Remove the product from the cart
    cart = cart.filter((item) => item.productId !== productId);

    // Save the updated cart back to localStorage
    localStorage.setItem("cart", JSON.stringify(cart));

    // Update state with the new cart
    setCart(cart);

    // Filter out the product from the filteredProducts list
    setFilteredProducts(
      filteredProducts.filter((product) => product.id !== productId)
    );
  };

  // const handleQuantityChange = async (productId, delta) => {
  //   const item = cart.find((item) => item.productId === productId);
  //   const newQuantity = item.quantity + delta;
  //   if (newQuantity > 0) {
  //     const updatedCart = await updateCartQuantity(productId, newQuantity);
  //     setCart(updatedCart);
  //   }
  // };

  const handleQuantityChange = (productId, delta) => {
    // Get current cart from localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Find the item in the cart
    const itemIndex = cart.findIndex((item) => item.productId === productId);
    if (itemIndex !== -1) {
      const item = cart[itemIndex];
      const newQuantity = item.quantity + delta;

      // Only update if the new quantity is greater than 0
      if (newQuantity > 0) {
        // Update the quantity in the cart
        cart[itemIndex].quantity = newQuantity;

        // Save the updated cart back to localStorage
        localStorage.setItem("cart", JSON.stringify(cart));

        // Update the state with the new cart
        setCart(cart);
      }
    }
  };

  const getProfileDetails = async () => {
    let reqBody = {
      accessToken: localStorage.getItem("userToken"),
    };
    try {
      const response = await axios.post(getProfile, reqBody);
      //   setLoading(false);
      if (response.status == 200) {
        setFirstLoginUser(response.data.profile.addresses);
        if (response.data.profile.addresses.length > 0) {
          let addId = response?.data?.profile?.defaultAddress?.id;
          const extractedId = addId.match(
            /gid:\/\/shopify\/MailingAddress\/(\d+)/
          );
          const result = extractedId ? extractedId[1] : null; // Extract only the numeric part
          setCustomerAddressId(result);
          const address =
            response?.data?.profile?.addresses?.[
              response?.data?.profile?.addresses?.length - 1
            ] || {};

          // setAddress1(address?.address1 || "");
          // setAddress2(address?.address2 || "");
          // setCityName(address?.city || "");
          // setProvinceName(address?.province || "");
          // setZipCode(address?.zip || "");

          setAddress1(response?.data?.profile?.defaultAddress?.address1 || "");
          setAddress2(response?.data?.profile?.defaultAddress?.address2 || "");
          setCityName(response?.data?.profile?.defaultAddress?.city || "");
          setProvinceName(
            response?.data?.profile?.defaultAddress?.province || ""
          );
          setZipCode(response?.data?.profile?.defaultAddress?.zip || "");

        }
      }
    } catch (err) {
      console.log(err, "::<<ERR>>");
    }
  };

  const handleNewUserAddAddress = async () => {
    if (
      !address1 ||
      !address2 ||
      !cityName ||
      !provinceName ||
      !countryCode ||
      !zipCode
    ) {
      setalertopen(true);
      setalertmsg("Please submit all the details.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    
    let reqBody = {
      accessToken: localStorage.getItem("userToken"),
      address1: address1,
      address2: address2,
      city: cityName,
      province: provinceName,
      country: countryCode,
      zip: zipCode,
    };
    // setLoading(true);
    try {
      const response = await axios.post(firstUserAddAddress, reqBody);
      //   setLoading(false);
      if (response.status == 200) {
        getProfileDetails();
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  const handleUpdateAddress = async () => {
    if (
      !address1 ||
      !address2 ||
      !cityName ||
      !provinceName ||
      !countryCode ||
      !zipCode
    ) {
      setalertopen(true);
      setalertmsg("Please submit all the details.");
      setTimeout(() => {
        setalertopen(false);
      }, 2000);
      return;
    }
    let reqBody = {
      accessToken: localStorage.getItem("userToken"),
      // firstName: localStorage.getItem("fname"),
      // lastName: localStorage.getItem("lname"),
      addressId: customerAddressId,
      address1: address1, //"123 Main Street india",
      address2: address2, //"Apt 4B",
      city: cityName, //"New York",
      province: provinceName, //"NY",
      country: countryCode, //countryCode, //"US",
      zip: zipCode, //"10001",
    };
    // setLoading(true);
    try {
      const response = await axios.post(updateUserDefaultAddress, reqBody);
      // const response = await axios.post(updaterProfile, reqBody);
      //   setLoading(false);
      if (response.status == 200) {
        // console.log(response.data.accessToken);
        getProfileDetails();
      }
    } catch (error) {
      console.log(error, "Error");
    }
  };

  // const calculateTotalAmount = () => {
  //   return cart.reduce((total, item) => {
  //     const product = filteredProducts.find((p) => p.id === item.productId);
  //     if (product) {
  //       const price = parseFloat(product.variants[0]?.price) || 0;
  //       return total + price * item.quantity;
  //     }
  //     return total;
  //   }, 0);
  // };

  const calculateTotalAmount = () => {
    // Get current cart from localStorage
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    // Calculate total amount by iterating through the cart
    return cart.reduce((total, item) => {
      // Find the product from the filteredProducts list
      const product = filteredProducts.find((p) => p.id === item.productId);
      if (product) {
        const price = parseFloat(product.variants[0]?.price) || 0;
        return total + price * item.quantity;
      }
      return total;
    }, 0);
  };

  return (
    <div className="photo-container main-section-container productDetailsStepperCard">
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={1}>
          <div className="d-flex justify-content-start align-items-center">
            <span className="backButtonDiv" onClick={() => navigate("/productdetails")}>
              <ArrowBackOutlinedIcon
                className="arrowBackBtn"
              />
            </span>
          </div>
        </Grid>
        <Grid
          item
          xs={10}
          className="d-flex justify-content-center align-items-center"
        >
          <Typography variant="h6" className="title">
            Checkout
          </Typography>
        </Grid>
        <Grid xs={1}>
          <Sidebar />
        </Grid>
      </Grid>

      <Box sx={{ width: "100%" }} className="MainStepperSection">
        <Grid container spacing={2} mt={3} className="">
          <Grid item xs={12} className="pt-0px">
            <div>
              <div className="order-summary-container">
                <Card className="summary-card commonCard">
                  <CardContent>
                    <Typography variant="h6" className="section-title">
                      Summary
                    </Typography>
                    {cart && cart.length === 0 && <p>Your cart is empty.</p>}

                    {cart &&
                      cart.map((item) => {
                        const product = filteredProducts.find(
                          (p) => p.id === item.productId
                        );
                        return product ? (
                          <Grid
                            container
                            alignItems="center"
                            spacing={2}
                            className="mt-0px"
                          >
                            <Grid item xs={5}>
                              <Card className="commonCard">
                                <CardContent className="pb-16px">
                                  <img
                                    src={product.images[0].src}
                                    alt="Product"
                                    className="product-image w-100"
                                  />
                                </CardContent>
                              </Card>
                            </Grid>

                            <Grid item xs={7}>
                              <Typography
                                variant="body1"
                                className="headingProduct"
                              >
                                {product.title}
                              </Typography>
                              <Typography variant="h6" className="price">
                                €{product.variants[0]?.price || "N/A"}
                              </Typography>
                              <div className="d-flex flex-direction-column align-items-center">
                                <div className="sliderButton quantityButton gap-10px">
                                  <div className="prevbtn">
                                    <button variant="contained quantityIcons">
                                      <RemoveIcon
                                        onClick={() =>
                                          handleQuantityChange(
                                            item.productId,
                                            -1
                                          )
                                        }
                                      />
                                    </button>
                                  </div>
                                  <span style={{ margin: "0 10px" }}>
                                    {item.quantity}
                                  </span>
                                  <div className="nextbtn">
                                    <button variant="contained quantityIcons">
                                      <AddIcon
                                        onClick={() =>
                                          handleQuantityChange(
                                            item.productId,
                                            1
                                          )
                                        }
                                      />
                                    </button>
                                  </div>
                                </div>
                                <Button
                                  variant="outlined"
                                  className="remove-button outlinedButton"
                                  style={{ marginTop: "10px" }}
                                  onClick={() =>
                                    handleRemoveFromCart(item.productId)
                                  }
                                >
                                  <DeleteOutlineIcon></DeleteOutlineIcon>
                                  Remove
                                </Button>
                              </div>
                            </Grid>
                          </Grid>
                        ) : null;
                      })}

                    {cart && cart.length > 0 && (
                      <div className="totalCartAmount">
                        <Typography variant="body1">
                          Total Amount: €{calculateTotalAmount().toFixed(2)}
                        </Typography>
                      </div>
                    )}
                  </CardContent>
                </Card>

                {/* Shipping Address Section */}
                <Card className="shipping-card commonCard">
                  <CardContent className="pb-16px">
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={10}>
                        <Typography variant="h6" className="section-title">
                          Shipping Address
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <CheckCircleOutlineIcon></CheckCircleOutlineIcon>
                      </Grid>
                    </Grid>

                    <Box
                      display="flex"
                      alignItems="center"
                      className="address-box"
                    >
                      <Typography
                        variant="body2"
                        className="text-left address-card"
                      >
                        {firstLoginUser.length > 0
                          ? `${address1 || ""} ${address2 || ""} ${
                              cityName || ""
                            }, ${provinceName || ""} ${zipCode || ""}`.trim() ||
                            ""
                          : ""}

                        {/* 12, Bay Brook, Sharps Rd, Keilor East, Melbourne,
                        Australia */}
                      </Typography>
                    </Box>
                    <Button
                      variant="text"
                      className="change-button"
                      onClick={handleOpen}
                    >
                      Add
                    </Button>
                  </CardContent>
                </Card>

                {/* Payment Section */}
                <Card className="payment-card commonCard">
                  <CardContent className="pb-16px">
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item xs={10}>
                        <Typography variant="h6" className="section-title">
                          Payment
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <CheckCircleOutlineIcon></CheckCircleOutlineIcon>
                      </Grid>
                    </Grid>

                    <Box
                      display="flex"
                      alignItems="center"
                      className="payment-box"
                    >
                      <div className="d-flex justify-content-start align-items-center paymentIcons gap-10px">
                        {/* <img src={imgurl.masterCardIcon}></img> */}
                        {/* <Typography variant="body2">
                          

                        </Typography> */}
                        <img src={imgurl.visaIcon} alt></img>
                        <img src={imgurl.masterIcon}></img>
                        <img src={imgurl.gpayIcon}></img>
                        <img src={imgurl.paymentIcon}></img>
                      </div>
                    </Box>
                    {/* <Button variant="text" className="change-button">
                      Change
                    </Button> */}
                  </CardContent>
                </Card>

                {cart.length > 0 && (
                  <button
                    onClick={handleCheckout}
                    className="commonButton"
                    // style={{
                    //   padding: "10px",
                    //   fontSize: "16px",
                    //   cursor: "pointer",
                    // }}
                  >
                    ✅ Proceed <span> to </span> Checkout
                  </button>
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>

      <Modal
        open={modalopen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="previewmodal addressmodal">
          <div className="closeBtnWrapper">
            <HighlightOffIcon onClick={handleClose} />
          </div>
          {/* <div className="mx-auto mt-5" style={{ maxWidth: '900px' }}> */}
          <Grid container spacing={2} className="profilefields">
            <form id="addressform" onSubmit={(e) => getaddr(e)}>
              <div className="addressline">
                <Grid item xs={12}>
                  <TextField
                    id="addr1"
                    name="addr1"
                    label="Address Line 1"
                    variant="outlined"
                    className="bluefield"
                    onChange={(e) => setAddress1(e.target.value)}
                    value={address1}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="addr2"
                    name="addr2"
                    label="Address Line 2"
                    variant="outlined"
                    className="whitefield"
                    onChange={(e) => setAddress2(e.target.value)}
                    value={address2}
                  />
                </Grid>
              </div>
              <div className="addressinfo">
                <Grid item xs={6}>
                  <TextField
                    id="city"
                    name="city"
                    label="City"
                    variant="outlined"
                    className="whitefield"
                    onChange={(e) => setCityName(e.target.value)}
                    value={cityName}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="province"
                    name="province"
                    label="Province"
                    variant="outlined"
                    className="whitefield"
                    onChange={(e) => setProvinceName(e.target.value)}
                    value={provinceName}
                  />
                </Grid>
              </div>

              <div className="addressinfo">
                <Grid item xs={12}>
                  <TextField
                    id="zipcode"
                    name="zipcode"
                    label="Zip"
                    type="number"
                    variant="outlined"
                    className="whitefield"
                    onChange={(e) => setZipCode(e.target.value)}
                    value={zipCode}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Select
                    value={countryCode}
                    onChange={handleCountryCodeChange}
                    className="country-select"
                    disableUnderline
                    variant="outlined"
                    name="country"
                  >
                    <MenuItem value="France">
                      <img
                        src={imgurl.france}
                        alt="Country Flag"
                        className="flag"
                      />
                      France
                    </MenuItem>
                    <MenuItem value="Spain">
                      <img
                        src={imgurl.spain}
                        alt="Country Flag"
                        className="flag"
                      />
                      Spain
                    </MenuItem>
                    <MenuItem value="Italy">
                      <img
                        src={imgurl.italy}
                        alt="Country Flag"
                        className="flag"
                      />
                      Italy
                    </MenuItem>
                    <MenuItem value="Switzerland">
                      <img
                        src={imgurl.switzerland}
                        alt="Country Flag"
                        className="flag"
                      />
                      Switzerland
                    </MenuItem>
                    <MenuItem value="India">
                      <img
                        src={imgurl.flag1}
                        alt="Country Flag"
                        className="flag"
                      />
                      India
                    </MenuItem>
                  </Select>
                </Grid>
              </div>

              <Grid item xs={12} className="addaddressbtn">
                <Button
                  variant="contained"
                  type="submit"
                  // onClick={() => handleNewUserAddAddress()}
                  onClick={() =>
                    firstLoginUser.length == 0
                      ? handleNewUserAddAddress()
                      : handleUpdateAddress()
                  }
                >
                  <p> Add Address </p>
                </Button>
              </Grid>
            </form>
          </Grid>
          {/* </div> */}
        </Box>
      </Modal>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
    </div>
  );
}
